export default __webpack_public_path__ + "static/media/SecondaryPhone.45f60fed.svg";